import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, fonts, mixins } from '@blend/consumer-components';

const styles = StyleSheet.create({
  headerWrapper: {
    ...fonts.Roboto,
    ...mixins.borderBottom(1, 'solid', colors.clayMinus2),
    alignItems: 'center',
    display: 'flex',
    paddingBottom: 5,
  },
  headerText: {
    color: colors.clayPlus3,
    display: 'inline',
    fontSize: 12,
    fontWeight: fonts.weight.bold,
    textTransform: 'uppercase',
    letterSpacing: '2px',
  },
  withIcon: {
    paddingLeft: 10,
  },
});

export interface PaneFormHeaderProps {
  iconComponent?: any;
  text: string;
}

export default class PaneFormHeader extends React.Component<PaneFormHeaderProps> {
  render() {
    const { iconComponent, text } = this.props;
    const Icon = iconComponent;

    return (
      <div className={css(styles.headerWrapper)}>
        {iconComponent && <Icon />}
        <h3 className={css(iconComponent && styles.withIcon, styles.headerText)}>{text}</h3>
      </div>
    );
  }
}
